if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        this.button = this.querySelector('.sticky-add-to-cart__button');

        if (!this.target || !this.button) return;

        this.onStickyClick = () => {
          if (!this.target.disabled && this.target.getAttribute('aria-disabled') !== 'true') {
            this.target.click();
          }
        };

        this.button.addEventListener('click', this.onStickyClick);

        this.targetObserver = new MutationObserver(() => this.syncButton());
        this.targetObserver.observe(this.target, {
          attributes: true,
          attributeFilter: ['aria-disabled', 'class', 'disabled'],
          childList: true,
          subtree: true,
        });

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const hasPassedButton = entry.boundingClientRect.bottom <= 0;
            this.setVisible(!entry.isIntersecting && hasPassedButton);
          },
          { threshold: 0.01 }
        );
        this.visibilityObserver.observe(this.target);

        this.syncButton();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onStickyClick);
        this.targetObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.button.tabIndex = visible ? 0 : -1;
      }

      syncButton() {
        const targetLabel = this.target.querySelector('span');
        const stickyLabel = this.button.querySelector('span');
        const label = targetLabel?.textContent.trim();

        if (label && stickyLabel) stickyLabel.textContent = label;

        const isDisabled = this.target.disabled || this.target.getAttribute('aria-disabled') === 'true';
        this.button.disabled = isDisabled;
        if (isDisabled) {
          this.button.setAttribute('aria-disabled', 'true');
        } else {
          this.button.removeAttribute('aria-disabled');
        }
        this.button.classList.toggle('loading', this.target.classList.contains('loading'));

        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !this.target.classList.contains('loading'));
      }
    }
  );
}
